export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  category: string;
  categories: string[];
  rating: number;
  duration: string;
  description: string;
  longDescription: string;
  director: string;
  actors: string[];
  region: string;
  language: string;
  releaseDate: string;
  posterUrl: string;
  backdropUrl: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  type: 'movie' | 'tv';
  episodeCount?: number;
  episodeInfo?: string;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部', icon: 'ri-movie-2-line' },
  { slug: 'action', name: '动作', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line' },
  { slug: 'romance', name: '爱情', icon: 'ri-heart-line' },
  { slug: 'scifi', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'animation', name: '动画', icon: 'ri-palette-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    year: 2026,
    category: 'scifi',
    categories: ['scifi', 'action', 'drama'],
    rating: 8.5,
    duration: '148分钟',
    description: '太阳急速老化，持续膨胀，即将吞没整个太阳系。人类在地球表面建造出巨大的推进器，带着地球踏上长达2500年的流浪之旅。',
    longDescription: '在不远的未来，太阳急速老化膨胀，地球面临着被吞没的危机。为了生存，人类联合政府决定启动"流浪地球计划"，在地球表面建造上万座行星发动机，推动地球离开太阳系，前往4.2光年外的新家园。这是一场长达2500年的太空流浪，也是一次关乎人类文明存亡的壮丽远征。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-02-10',
    posterUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20The%20Wandering%20Earth%203%20with%20astronauts%20in%20space%20suits%20and%20massive%20planet%20engines%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20orange%20flames%2C%20professional%20film%20poster%20design&width=440&height=620&seq=poster-movie-1&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20landscape%20with%20massive%20planet%20engines%20on%20Earth%20surface%20firing%20into%20space%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20cinematic%20wide%20shot%2C%20atmospheric%20and%20grand%20scale&width=1600&height=700&seq=backdrop-movie-1&orientation=landscape',
    isHot: true,
    isNew: true,
    isRecommended: true,
    type: 'movie',
  },
  {
    id: 'movie-2',
    title: '封神第二部',
    titleEn: 'Creation of the Gods II',
    year: 2025,
    category: 'action',
    categories: ['action', 'drama'],
    rating: 8.2,
    duration: '155分钟',
    description: '殷商末年，纣王暴虐，天下大乱。姜子牙携封神榜下山，辅佐武王伐纣。一场人、仙、妖三界的宏大战争即将拉开帷幕。',
    longDescription: '商朝末年，纣王无道，宠信妖妃妲己，残害忠良，民不聊生。元始天尊命姜子牙携封神榜下山，寻找天下共主，辅佐明君讨伐暴君。姬发率领西岐大军，联合各路诸侯，与纣王的商朝大军展开了惊心动魄的决战。各路神仙妖魔纷纷登场，阐教与截教的冲突愈演愈烈，最终演变为一场改变三界格局的浩大战争。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-07-18',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20film%20poster%20Creation%20of%20the%20Gods%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20golden%20and%20crimson%20color%20scheme%2C%20dramatic%20composition%2C%20professional%20movie%20poster%20design&width=440&height=620&seq=poster-movie-2&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20battlefield%20with%20thousands%20of%20warriors%20and%20mythical%20beasts%2C%20epic%20scale%2C%20golden%20sunset%20lighting%2C%20cinematic%20wide%20shot%2C%20dramatic%20atmosphere&width=1600&height=700&seq=backdrop-movie-2&orientation=landscape',
    isHot: true,
    isNew: false,
    isRecommended: true,
    type: 'movie',
  },
  {
    id: 'movie-3',
    title: '你好，李焕英2',
    titleEn: 'Hi, Mom 2',
    year: 2026,
    category: 'comedy',
    categories: ['comedy', 'drama'],
    rating: 8.8,
    duration: '132分钟',
    description: '一段跨越时空的母女亲情故事，笑中带泪，温暖人心。贾晓玲带着全新的感悟回到过去，与年轻的母亲共同经历了一段难忘的时光。',
    longDescription: '贾晓玲在经历了一系列人生起伏后，又一次获得了穿越时空的机会。这一次，她带着更深的感悟和更成熟的心态回到了母亲李焕英的青春年代。她不再试图改变母亲的命运，而是想要真正地去了解这个给了她生命的人，去感受母亲年轻时的快乐、梦想与遗憾。在这个过程中，她逐渐明白了爱的真谛，也学会了如何面对失去与拥有。',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾', '陈赫'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-01-25',
    posterUrl: 'https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20comedy%20drama%20film%20poster%20Hi%20Mom%202%20with%20mother%20and%20daughter%20embracing%20in%201980s%20China%2C%20warm%20retro%20tone%2C%20nostalgic%20lighting%2C%20professional%20film%20poster&width=440&height=620&seq=poster-movie-3&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%201980s%20Chinese%20factory%20town%20scene%20with%20warm%20sunset%20lighting%2C%20retro%20bicycles%20and%20old%20buildings%2C%20emotional%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-movie-3&orientation=landscape',
    isHot: true,
    isNew: true,
    isRecommended: true,
    type: 'movie',
  },
  {
    id: 'movie-4',
    title: '深海2',
    titleEn: 'Deep Sea 2',
    year: 2026,
    category: 'animation',
    categories: ['animation', 'drama'],
    rating: 8.4,
    duration: '118分钟',
    description: '少女参宿在一次意外中坠入神秘的深海世界，开启了一段关于勇气、友情与奇幻冒险的旅程。',
    longDescription: '少女参宿在一次海上航行中意外落水，醒来时发现自己身处一个光怪陆离的深海世界。这里有着绚丽的珊瑚森林、奇幻的深海生物和一个神秘的水下文明。为了找到回家的路，参宿必须与性格各异的新朋友们一起，穿越危险的海域，解开深藏海底的古老秘密。',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-06-01',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20Deep%20Sea%202%20with%20a%20young%20girl%20in%20a%20magical%20underwater%20world%2C%20vibrant%20bioluminescent%20colors%2C%20dreamlike%20atmosphere%2C%20stunning%20animation%20art%20style&width=440&height=620&seq=poster-movie-4&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Magical%20underwater%20fantasy%20world%20with%20colorful%20coral%20reefs%20and%20glowing%20sea%20creatures%2C%20dreamlike%20atmosphere%2C%20vibrant%20colors%2C%20cinematic%20animated%20style&width=1600&height=700&seq=backdrop-movie-4&orientation=landscape',
    isHot: false,
    isNew: true,
    isRecommended: true,
    type: 'movie',
  },
  {
    id: 'movie-5',
    title: '孤注一掷2',
    titleEn: 'No More Bets 2',
    year: 2025,
    category: 'suspense',
    categories: ['suspense', 'drama', 'action'],
    rating: 8.1,
    duration: '135分钟',
    description: '网络诈骗团伙再次升级手段，一场精心设计的陷阱正在等着毫不知情的受害者们。正义与罪恶的较量再度升级。',
    longDescription: '在前作揭露境外网络诈骗的基础上，续集聚焦于新型AI换脸诈骗和加密货币洗钱等高科技犯罪手段。一位退役网络安全工程师在发现亲人被骗后，决定孤身潜入犯罪团伙内部，与跨国诈骗集团展开了一场惊心动魄的智斗。随着调查的深入，他发现这股犯罪势力的触角远比想象中更加深远。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君', '咏梅'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-09-30',
    posterUrl: 'https://readdy.ai/api/search-image?query=Suspenseful%20Chinese%20crime%20thriller%20film%20poster%20No%20More%20Bets%202%20with%20dark%20neon-lit%20cyber%20crime%20aesthetic%2C%20hacker%20silhouette%2C%20tense%20atmosphere%2C%20professional%20movie%20poster&width=440&height=620&seq=poster-movie-5&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Dark%20neon-lit%20Southeast%20Asian%20city%20at%20night%20with%20rain-slicked%20streets%2C%20cyber%20crime%20headquarters%20vibe%2C%20tense%20thriller%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-movie-5&orientation=landscape',
    isHot: true,
    isNew: false,
    isRecommended: false,
    type: 'movie',
  },
  {
    id: 'movie-6',
    title: '长津湖之水门桥',
    titleEn: 'The Battle at Lake Changjin II',
    year: 2024,
    category: 'action',
    categories: ['action', 'drama'],
    rating: 8.3,
    duration: '149分钟',
    description: '抗美援朝战争中，志愿军七连战士们在极度严寒和物资匮乏的条件下，以钢铁般的意志守卫水门桥。',
    longDescription: '1950年冬，抗美援朝战争进入关键阶段。志愿军第七穿插连的战士们奉命坚守水门桥，阻止美军陆战一师的撤退路线。在零下四十度的极寒天气中，战士们不仅要与装备精良的敌人作战，还要与恶劣的自然环境抗争。弹药匮乏、补给断绝，但他们以惊人的意志力和无畏的牺牲精神，用血肉之躯筑起了一道坚不可摧的防线。',
    director: '陈凯歌',
    actors: ['吴京', '易烊千玺', '朱亚文', '李晨', '韩东君'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2024-09-30',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20war%20film%20poster%20The%20Battle%20at%20Lake%20Changjin%20II%20with%20soldiers%20in%20winter%20combat%20gear%2C%20snowy%20battlefield%2C%20heroic%20composition%2C%20professional%20movie%20poster&width=440&height=620&seq=poster-movie-6&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Wintry%20Korean%20War%20battlefield%20with%20soldiers%20in%20deep%20snow%2C%20frozen%20landscape%2C%20dramatic%20smoke%20and%20explosions%2C%20cinematic%20war%20epic%20wide%20shot&width=1600&height=700&seq=backdrop-movie-6&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: true,
    type: 'movie',
  },
  {
    id: 'movie-7',
    title: '热烈2',
    titleEn: 'One and Only 2',
    year: 2026,
    category: 'drama',
    categories: ['drama', 'comedy'],
    rating: 8.0,
    duration: '128分钟',
    description: '街舞少年陈烁在经历了全国大赛的洗礼后，带着更加成熟的舞技和坚定的信念，向着更高的舞台发起冲击。',
    longDescription: '从全国街舞大赛载誉归来的陈烁，收到了国际街舞大赛的邀请函。面对来自世界各地的顶尖舞者，他意识到自己还有很长的路要走。在教练和队友们的帮助下，陈烁开始了一段全新的训练之旅。他需要突破自己的瓶颈，融合不同的舞蹈风格，同时也要应对来自家庭、爱情和自我怀疑的压力。',
    director: '大鹏',
    actors: ['王一博', '黄渤', '刘敏涛', '岳云鹏'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-04-28',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20dance%20drama%20film%20poster%20One%20and%20Only%202%20with%20street%20dancer%20in%20dynamic%20pose%2C%20vibrant%20neon%20stage%20lighting%2C%20energetic%20composition%2C%20professional%20movie%20poster&width=440&height=620&seq=poster-movie-7&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Grand%20international%20dance%20competition%20stage%20with%20colorful%20lighting%20and%20enthusiastic%20crowd%2C%20energetic%20atmosphere%2C%20neon%20lights%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-movie-7&orientation=landscape',
    isHot: false,
    isNew: true,
    isRecommended: false,
    type: 'movie',
  },
  {
    id: 'movie-8',
    title: '古董局中局3',
    titleEn: 'Antique Bureau 3',
    year: 2025,
    category: 'suspense',
    categories: ['suspense', 'drama'],
    rating: 7.8,
    duration: '122分钟',
    description: '一件神秘国宝重现江湖，掀起了一场涉及古董、拍卖、造假的惊天骗局。许愿再次出山，揭开层层迷雾。',
    longDescription: '一件据传流失海外多年的唐代国宝突然出现在香港的一场拍卖会上，引起了全球收藏界的关注。许愿收到匿名委托，要求验证这件国宝的真伪。然而，随着调查的深入，他发现这不仅仅是一起简单的古董鉴伪案件，背后隐藏着一个横跨数十年的文物造假网络和一场关于文化传承的巨大阴谋。',
    director: '郭子健',
    actors: ['雷佳音', '李现', '辛芷蕾', '葛优'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-12-12',
    posterUrl: 'https://readdy.ai/api/search-image?query=Mystery%20Chinese%20film%20poster%20Antique%20Bureau%203%20with%20ancient%20Chinese%20artifact%20in%20spotlight%2C%20dark%20museum%20setting%2C%20suspenseful%20atmosphere%2C%20professional%20movie%20poster&width=440&height=620&seq=poster-movie-8&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20auction%20house%20interior%20with%20spotlight%20on%20ancient%20Chinese%20artifact%2C%20elegant%20dark%20atmosphere%2C%20mysterious%20vibe%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-movie-8&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: true,
    type: 'movie',
  },
  {
    id: 'tv-1',
    title: '庆余年2',
    titleEn: 'Joy of Life 2',
    year: 2024,
    category: 'drama',
    categories: ['drama', 'action', 'comedy'],
    rating: 8.7,
    duration: '45分钟/集',
    description: '范闲在南庆朝堂之上的传奇故事继续。面对更加强大的对手，他步步为营，在权谋与理想之间寻找平衡。',
    longDescription: '范闲从北齐归来后，发现自己已经深陷南庆朝堂的权力漩涡之中。监察院内暗流涌动，皇室内部的矛盾日益激化，而他与林婉儿之间的感情也经受着重重考验。与此同时，一个关于他身世的惊天秘密逐渐浮出水面，这个秘密将彻底改变他对这个世界的认知。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2024-05-16',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20Joy%20of%20Life%202%20with%20elegant%20ancient%20Chinese%20court%20official%2C%20royal%20palace%20background%2C%20golden%20and%20crimson%20tones%2C%20professional%20drama%20poster&width=440&height=620&seq=poster-tv-1&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20imperial%20palace%20courtyard%20with%20officials%20in%20traditional%20robes%2C%20golden%20sunset%20lighting%2C%20elegant%20architecture%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-tv-1&orientation=landscape',
    isHot: true,
    isNew: false,
    isRecommended: true,
    type: 'tv',
    episodeCount: 36,
    episodeInfo: '全36集',
  },
  {
    id: 'tv-2',
    title: '三体',
    titleEn: 'Three-Body',
    year: 2023,
    category: 'scifi',
    categories: ['scifi', 'drama', 'suspense'],
    rating: 8.9,
    duration: '50分钟/集',
    description: '根据刘慈欣同名科幻小说改编。纳米科学家汪淼被卷入一场涉及外星文明的巨大阴谋中，人类文明的命运悬于一线。',
    longDescription: '2007年，地球基础科学研究遭遇异常扰动，一时间全球科学界人心惶惶。纳米科学家汪淼被警官史强带入一个名为"科学边界"的神秘组织，由此接触到了一个名为"三体"的外星文明。随着调查的深入，汪淼发现这个外星文明正在向地球进发，而人类社会中早已潜伏着他们的支持者。一场关乎人类文明存亡的博弈就此拉开序幕。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2023-01-15',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20Three-Body%20with%20mysterious%20cosmic%20background%20and%20three%20suns%2C%20scientific%20symbols%2C%20dark%20atmospheric%20tone%2C%20professional%20drama%20poster&width=440&height=620&seq=poster-tv-2&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20cosmic%20landscape%20with%20three%20suns%20in%20alien%20sky%2C%20strange%20planet%20surface%2C%20sci-fi%20atmosphere%2C%20vast%20scale%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-tv-2&orientation=landscape',
    isHot: true,
    isNew: false,
    isRecommended: true,
    type: 'tv',
    episodeCount: 30,
    episodeInfo: '全30集',
  },
  {
    id: 'tv-3',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    year: 2024,
    category: 'drama',
    categories: ['drama', 'romance'],
    rating: 9.0,
    duration: '50分钟/集',
    description: '九十年代的上海，处处是机遇与挑战。阿宝在改革开放的浪潮中崛起，书写了一段跌宕起伏的传奇人生。',
    longDescription: '1990年代的上海，黄浦江两岸每天都在发生着翻天覆地的变化。阿宝从一个小商贩做起，凭借敏锐的商业嗅觉和过人的胆识，一步步成长为黄河路上赫赫有名的人物。在这条充满机遇与陷阱的路上，他遇到了形形色色的人——有情深义重的朋友，有暗中算计的对手，也有让他心动不已的女人。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    region: '中国大陆',
    language: '汉语普通话 / 上海话',
    releaseDate: '2024-12-27',
    posterUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20drama%20TV%20series%20poster%20Blossoms%20Shanghai%20with%201990s%20Shanghai%20aesthetic%2C%20stylish%20characters%2C%20neon%20city%20lights%2C%20Wong%20Kar-wai%20style%2C%20professional%20drama%20poster&width=440&height=620&seq=poster-tv-3&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20with%20neon%20lights%20and%20the%20Bund%20at%20night%2C%20retro%20modern%20vibe%2C%20stylish%20cinematic%20atmosphere%2C%20wide%20shot&width=1600&height=700&seq=backdrop-tv-3&orientation=landscape',
    isHot: true,
    isNew: true,
    isRecommended: true,
    type: 'tv',
    episodeCount: 30,
    episodeInfo: '全30集',
  },
  {
    id: 'tv-4',
    title: '漫长的季节',
    titleEn: 'The Long Season',
    year: 2023,
    category: 'suspense',
    categories: ['suspense', 'drama'],
    rating: 9.3,
    duration: '60分钟/集',
    description: '一座北方小城，一起跨越二十年的悬案。出租车司机王响在追查真相的过程中，揭开了一段尘封已久的往事。',
    longDescription: '退休的火车司机王响，因为一起偶然的事件重新卷入了一桩二十年前的碎尸案调查中。当年，这起案件改变了许多人的命运——王响失去了挚爱的家人，老友龚彪的人生从此走了下坡路，而当年的刑警马德胜也一直没能放下这个悬案。如今，三个人因为不同的原因再次聚在一起，踏上了一条追寻真相的不归路。',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2023-04-22',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20The%20Long%20Season%20with%20northern%20Chinese%20industrial%20town%20aesthetic%2C%20mysterious%20mood%2C%20retired%20man%20silhouette%2C%20professional%20drama%20poster&width=440&height=620&seq=poster-tv-4&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Northeastern%20Chinese%20industrial%20town%20in%20autumn%20with%20old%20factory%20buildings%20and%20railway%20tracks%2C%20melancholic%20atmosphere%2C%20overcast%20sky%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-tv-4&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: true,
    type: 'tv',
    episodeCount: 12,
    episodeInfo: '全12集',
  },
  {
    id: 'movie-9',
    title: '龙马精神2',
    titleEn: 'Ride On 2',
    year: 2025,
    category: 'comedy',
    categories: ['comedy', 'action', 'drama'],
    rating: 7.6,
    duration: '120分钟',
    description: '过气武打明星老罗在经历了一次意外后，重新审视自己的人生，与疏远多年的女儿一起踏上了一段修复亲情的旅程。',
    longDescription: '曾经红极一时的武打明星老罗，如今只能靠一些不起眼的龙套角色维持生计。他的爱马"赤兔"是他唯一的伙伴和最珍贵的财富。当女儿小宝突然带着一本旧相册出现在他面前时，老罗尘封已久的记忆被唤醒。在女儿的陪伴下，他开始回顾自己辉煌与落寞交织的演艺生涯，也逐渐理解了亲情的真正意义。',
    director: '杨子',
    actors: ['成龙', '刘浩存', '郭麒麟', '吴京'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-04-07',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20action%20comedy%20film%20poster%20Ride%20On%202%20with%20aging%20stuntman%20and%20his%20beloved%20horse%2C%20warm%20emotional%20tone%2C%20professional%20movie%20poster&width=440&height=620&seq=poster-movie-9&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Chinese%20film%20studio%20backlot%20with%20stunt%20equipment%20and%20a%20beautiful%20horse%2C%20golden%20hour%20lighting%2C%20nostalgic%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-movie-9&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: false,
    type: 'movie',
  },
  {
    id: 'movie-10',
    title: '消失的她2',
    titleEn: 'Lost in the Stars 2',
    year: 2025,
    category: 'suspense',
    categories: ['suspense', 'drama'],
    rating: 7.9,
    duration: '130分钟',
    description: '一位神秘女子在豪华游轮上离奇失踪，她的丈夫在寻找真相的过程中，发现妻子隐藏着不为人知的秘密。',
    longDescription: '何非和妻子李木子登上一艘前往东南亚的豪华游轮，计划开启一段浪漫的蜜月旅行。然而，在一个风雨交加的夜晚，李木子突然从船上消失得无影无踪。何非疯狂地寻找妻子，却发现船上没有人记得李木子的存在，甚至连登船记录上都没有她的名字。随着调查的深入，何非逐渐意识到妻子的失踪背后隐藏着一个精心策划的阴谋。',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-06-21',
    posterUrl: 'https://readdy.ai/api/search-image?query=Suspense%20Chinese%20film%20poster%20Lost%20in%20the%20Stars%202%20with%20luxury%20cruise%20ship%20and%20mysterious%20woman%20silhouette%2C%20dark%20ocean%20background%2C%20thriller%20vibe%2C%20professional%20movie%20poster&width=440&height=620&seq=poster-movie-10&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Luxury%20cruise%20ship%20on%20dark%20ocean%20under%20stormy%20sky%2C%20mysterious%20and%20tense%20atmosphere%2C%20dramatic%20lightning%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-movie-10&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: true,
    type: 'movie',
  },
  {
    id: 'tv-5',
    title: '狂飙',
    titleEn: 'The Knockout',
    year: 2023,
    category: 'drama',
    categories: ['drama', 'action', 'suspense'],
    rating: 9.1,
    duration: '45分钟/集',
    description: '一线刑警安欣与黑恶势力展开长达二十年的斗争，展现了扫黑除恶专项斗争的艰辛与成就。',
    longDescription: '2000年，京海市刑警安欣在调查一起看似普通的案件时，意外发现了盘踞当地多年的黑恶势力团伙。从那时起，他开始了与这个犯罪集团长达二十年的漫长斗争。在这个过程中，他失去了战友，失去了爱情，甚至一度被调离岗位，但他从未放弃对正义的追求。二十年后，随着全国扫黑除恶专项斗争的深入开展，安欣终于有机会将这颗毒瘤连根拔起。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2023-01-14',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20The%20Knockout%20with%20police%20detective%20facing%20underworld%20figures%2C%20dark%20urban%20setting%2C%20intense%20contrast%2C%20professional%20drama%20poster&width=440&height=620&seq=poster-tv-5&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Chinese%20coastal%20city%20at%20night%20with%20contrast%20between%20modern%20skyscrapers%20and%20old%20neighborhoods%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-tv-5&orientation=landscape',
    isHot: true,
    isNew: false,
    isRecommended: true,
    type: 'tv',
    episodeCount: 39,
    episodeInfo: '全39集',
  },
  {
    id: 'tv-6',
    title: '去有风的地方',
    titleEn: 'Meet Yourself',
    year: 2023,
    category: 'romance',
    categories: ['romance', 'drama'],
    rating: 8.6,
    duration: '45分钟/集',
    description: '都市白领许红豆在人生低谷时来到云南大理，在风花雪月中找到了生活的另一种可能，也邂逅了一段美好的爱情。',
    longDescription: '闺蜜的突然离世让许红豆意识到自己一直活在焦虑和压力之中。她辞去了北京的高薪工作，只身前往云南大理，住进了洱海边的一间民宿。在这里，她遇到了放弃城市生活回乡创业的谢之遥，以及一群性格各异但都热爱生活的人们。在苍山洱海的美景中，许红豆慢慢放慢了脚步，学会了与自己和解，也重新找到了生活的意义。',
    director: '丁梓光',
    actors: ['刘亦菲', '李现', '胡冰卿', '牛骏峰'],
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2023-01-03',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20drama%20TV%20series%20poster%20Meet%20Yourself%20with%20couple%20in%20Dali%20Yunnan%20landscape%2C%20Erhai%20Lake%20background%2C%20warm%20natural%20lighting%2C%20professional%20drama%20poster&width=440&height=620&seq=poster-tv-6&orientation=portrait',
    backdropUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20Dali%20Yunnan%20landscape%20with%20Erhai%20Lake%20and%20Cangshan%20Mountains%2C%20traditional%20Bai%20architecture%2C%20golden%20sunset%2C%20peaceful%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=backdrop-tv-6&orientation=landscape',
    isHot: false,
    isNew: false,
    isRecommended: true,
    type: 'tv',
    episodeCount: 40,
    episodeInfo: '全40集',
  },
];

export const getMoviesByCategory = (slug: string): Movie[] => {
  if (slug === 'all') return movies;
  return movies.filter((m) => m.categories.includes(slug));
};

export const getHotMovies = (): Movie[] => movies.filter((m) => m.isHot);
export const getNewMovies = (): Movie[] => movies.filter((m) => m.isNew);
export const getRecommendedMovies = (): Movie[] => movies.filter((m) => m.isRecommended);
export const getMovieById = (id: string): Movie | undefined => movies.find((m) => m.id === id);